import { render, staticRenderFns } from "./PatientStatusIcon.vue?vue&type=template&id=0d39db67&scoped=true&"
import script from "./PatientStatusIcon.vue?vue&type=script&lang=js&"
export * from "./PatientStatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./PatientStatusIcon.vue?vue&type=style&index=0&id=0d39db67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d39db67",
  null
  
)

export default component.exports